import { WorkspaceCountSummary } from '@driftt/api-types'
import { IsoCountriesWithMeta } from '@driftt/conditions-core'
import * as R from 'ramda'

import { DEFAULT_WORKSPACE } from 'constants/workspaces'

export function filterDefaultWorkspaceId(workspaceIds: string[] = []) {
  return workspaceIds.filter((id) => !R.equals(id, DEFAULT_WORKSPACE.id))
}

export const getDefaultPlaybookCounts = R.compose<
  Record<string, WorkspaceCountSummary>,
  WorkspaceCountSummary,
  number
>(R.pathOr(0, ['objectCounts', 'PLAYBOOK']), R.prop(DEFAULT_WORKSPACE.id))

// filter default workspaceId if there are no playbooks in it
export const filterDefaultWorkspaceIfEmpty = ({
  workspaceIds,
  playbooksInDefault,
}: {
  workspaceIds: string[]
  playbooksInDefault: number
}) =>
  !R.isNil(playbooksInDefault) && playbooksInDefault > 0
    ? workspaceIds
    : filterDefaultWorkspaceId(workspaceIds)

export const IsoCountryCodeToName = (countryCode: string) => {
  const countryMeta = R.find(R.propEq('alpha-2', countryCode))(
    IsoCountriesWithMeta
  )
  return R.pathOr('', ['name'], countryMeta)
}

export const DEFAULT_WORKSPACE_ID = 'default'
export const DEFAULT_WORKSPACE_TARGETING_TEXT =
  'This playbook exists in your default workspace. Workspace targeting conditions do not apply to this workspace.'
